import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { t } from "ttag";

import type { SimpleProductBlock as SimpleProductBlockValue } from "@reactivated";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { StarRatingStars } from "../StarRating";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: SimpleProductBlockValue }>;

export const SimpleProductBlock = (props: IProps): React.JSX.Element => {
    const slug = props.value.product?.slug ?? "";
    return (
        <section
            className={classNames(
                "simple-product",
                slug === "pillow"
                    ? styles.simpleProductPillow
                    : `simple-product--${slug}`,
                getGlobalSpacingClasses(props.value.spacing),
            )}
            style={{
                backgroundImage: props.value.image
                    ? `url('${props.value.image.url}')`
                    : undefined,
            }}
        >
            <div className={styles.simpleProductMainContainer}>
                <div className={styles.simpleProductTitle}>
                    {props.value.title}
                </div>
                <div
                    className={styles.simpleProductCopy}
                    dangerouslySetInnerHTML={{ __html: props.value.copy ?? "" }}
                ></div>
                <div className="simple-product__links">
                    <a
                        className={concatClassNames([
                            styles.simpleProductButton,
                            "button",
                        ])}
                        href={props.value.product?.url}
                    >
                        Shop Now
                    </a>
                    {(props.value.stars ?? 0) > 0 ? (
                        <div>
                            <StarRatingStars rating={props.value.stars} />
                        </div>
                    ) : null}
                    <div className={styles.simpleProductPricing}>
                        {interpolate(t`$%(price)s each`, {
                            price: props.value.price,
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};
